import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export function SearchTestTextRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SearchTestText', {
		url: '/admin/nosql/test/text',
		controllerAs: 'vm',
		controller: SearchTestTextCtrl,
		templateUrl: '/ng/hub/Search/Test/Text/SearchTestTextCtrl.html',
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Search/Test/Text/SearchTestTextCtrl.css'),
			$title: () => 'SearchTestText page',
		},
	});
}

export class SearchTestTextCtrl {
	constructor(Api) {
		'ngInject';
		this.Api = Api;
		this.mode = 'input';
	}

	runSearch() {
		this.mode = 'searching';
		const params = {
			text: this.docText,
			term: this.searchTerm,
		};
		this.Api.post('/nosql/test/text', params).then(
			result => {
				this.doesMatch = result.doesMatch;
				this.mode = 'result';
				this.result = this.formatResult(result.tokens);
			},
			() => {
				this.mode = 'result';
				this.result = 'Network error.';
			}
		);
	}

	formatResult(tokens) {
		const noSymbols = this.docText.replace(/[.,;&-]+/, ' ');
		const origWords = noSymbols.split(/\s+/);
		const indexed = _.indexBy(tokens, 'position');
		const resultWords = [];
		origWords.forEach((origWord, i) => {
			if (indexed[i]) {
				resultWords[i] = indexed[i].token + _.repeat(' ', origWord.length - indexed[i].token.length);
			} else {
				resultWords[i] = _.repeat(' ', origWord.length);
			}
		});
		const maxLength = 100;
		const origLines = [];
		const resultLines = [];
		let origLine = '';
		let resultLine = '';
		while (origWords.length) {
			let origWord = origWords.shift();
			let resultWord = resultWords.shift();
			if (origLine.length + origWord.length > maxLength) {
				origLines.push(origLine);
				resultLines.push(resultLine);
				origLine = '';
				resultLine = '';
			}
			origLine += origWord + ' ';
			resultLine += resultWord + ' ';
		}
		origLines.push(origLine);
		resultLines.push(resultLine);
		const lines = [];
		for (let i = 0, len = origLines.length; i < len; i++) {
			lines.push(origLines[i], resultLines[i], ' ');
		}
		return lines;

		// const lines = [];
		// const line = { length: 0, origWords: [], resultWords: [] };
		// const wrapAfter = 100;
		// const origWords = this.docText.split(/[^a-zA-Z']+/);
		// let position = 0;
		// origWords.forEach(origWord => {
		// 	if (line.length > wrapAfter) {
		// 		lines.push(line.origWords.join(' '), line.resultWords.join(' '), '');
		// 		line.length = 0;
		// 		line.origWords = [];
		// 		line.resultWords = [];
		// 	}
		// 	let resultWord;
		// 	if (tokens.length === 0 || position < tokens[0].position) {
		// 		resultWord = _.repeat(' ', origWord.length);
		// 		position++;
		// 	}
		// 	else {
		// 		let token = tokens.shift();
		// 		resultWord = token.token + _.repeat(' ', origWord.length - token.token.length);
		// 	}
		// 	line.origWords.push(origWord);
		// 	line.resultWords.push(resultWord);
		// 	line.length += origWord.length + 1;
		// 	position++;
		// });
		// lines.push(line.origWords.join(' '), line.resultWords.join(' '), '');
		// return lines;
	}
}
